// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbedReportPartDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!function () {

  var m = require('mobx');

  function EmbedReportPartDetail(data) {
    var props = {
      id: null,
      title: null,
      width: null,
      height: null
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param {Object} embed report part detail data
   */
  EmbedReportPartDetail.prototype.populateData = m.action(function (data) {
    this.id = data.id;
    this.title = data.title;
    this.width = data.width;
    this.height = data.height;
  });

  module.exports = EmbedReportPartDetail;
}();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.EmbedReportPartDetail.js